import { useState, useEffect, useRef } from "react";
import dashCamisas from "../data/dashCamisas";
import CardCamisa from "../components/CardCamisa/CardCamisa";
import ModalCamisa from "../components/ModalCamisa/ModalCamisa";

export default function Dashboard() {
  const [camisaSelecionada, setCamisaSelecionada] = useState(null);
  const [heroIndex, setHeroIndex] = useState(0);

  const selecaoRef = useRef(null);
  const retroRef = useRef(null);
  const newCollectRef = useRef(null);

  const heroCamisas = dashCamisas.slice(0, 10);

  useEffect(() => {
    const interval = setInterval(() => {
      setHeroIndex((prev) => (prev + 1) % heroCamisas.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [heroCamisas.length]);

  const destaque = heroCamisas[heroIndex];
  const selecao = dashCamisas.slice(0, 10);
  const retros = dashCamisas.filter((c) => c.categoria === "retro");
  const camisasCopa = dashCamisas.filter(
    (c) => c.categoria === "novidade-copa"
  );

  const scroll = (ref, direction) => {
    if (!ref.current) return;

    const scrollAmount = 300;

    const { scrollLeft, scrollWidth, clientWidth } = ref.current;

    if (direction === "right") {
      const maxScroll = scrollWidth - clientWidth;

      if (scrollLeft >= maxScroll) return;

      ref.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    } else {
      if (scrollLeft <= 0) return;

      ref.current.scrollBy({
        left: -scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="dashboard">
      {/* HERO */}
      <section className="hero">
        <img src={destaque.imagens[0]} alt={destaque.nome} />

        <div className="hero-info">
          <h1>{destaque.nome}</h1>
        </div>

        <div className="hero-dots">
          {heroCamisas.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === heroIndex ? "active" : ""}`}
              onClick={() => setHeroIndex(index)}
            />
          ))}
        </div>
      </section>
      {/* SELEÇÃO */}
      <section>
        <h2 className="section-title">🏆 Seleção da coleção</h2>

        <div className="carousel-wrapper">
          <button
            className="carousel-btn left"
            onClick={() => scroll(selecaoRef, "left")}
          >
            ‹
          </button>

          <div ref={selecaoRef} className="carousel">
            {selecao.map((camisa) => (
              <CardCamisa
                key={camisa.id}
                camisa={camisa}
                onClick={setCamisaSelecionada}
              />
            ))}
          </div>

          <button
            className="carousel-btn right"
            onClick={() => scroll(selecaoRef, "right")}
          >
            ›
          </button>
        </div>
      </section>

      {/* Lançamentos da copa */}
      <section>
        <h2 className="section-title">⭐ Lançamentos da copa 2026</h2>

        <div className="carousel-wrapper">
          <button
            className="carousel-btn left"
            onClick={() => scroll(newCollectRef, "left")}
          >
            ‹
          </button>

          <div ref={newCollectRef} className="carousel">
            {camisasCopa.map((camisa) => (
              <CardCamisa
                key={camisa.id}
                camisa={camisa}
                onClick={setCamisaSelecionada}
              />
            ))}
          </div>

          <button
            className="carousel-btn right"
            onClick={() => scroll(newCollectRef, "right")}
          >
            ›
          </button>
        </div>
      </section>
      {/* RETRÔS */}
      <section>
        <h2 className="section-title">⭐ Retrôs favoritos</h2>

        <div className="carousel-wrapper">
          <button
            className="carousel-btn left"
            onClick={() => scroll(retroRef, "left")}
          >
            ‹
          </button>

          <div ref={retroRef} className="carousel">
            {retros.map((camisa) => (
              <CardCamisa
                key={camisa.id}
                camisa={camisa}
                onClick={setCamisaSelecionada}
              />
            ))}
          </div>

          <button
            className="carousel-btn right"
            onClick={() => scroll(retroRef, "right")}
          >
            ›
          </button>
        </div>
      </section>
      {camisaSelecionada && (
        <ModalCamisa
          camisa={camisaSelecionada}
          onClose={() => setCamisaSelecionada(null)}
        />
      )}
    </div>
  );
}
